import { jsx } from 'react/jsx-runtime';
import { useTheme } from 'react-jss';
import { safeRest } from '@wds/utils';
import { createMemoStyles } from '@wds/styles';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var useStyles = createMemoStyles(function (theme) {
  var type = theme.type,
    spacing = theme.spacing,
    palette = theme.palette;
  return {
    wrenchLabel: {
      boxSizing: 'border-box',
      display: 'block',
      color: function (_a) {
        var muted = _a.muted;
        return muted ? palette.text.darkMuted : palette.text.dark;
      },
      fontFamily: type.fontFamily.base,
      '-webkit-font-smoothing': 'antialiased',
      fontSize: function (_a) {
        var plain = _a.plain;
        return plain ? type.fontSize.body : type.fontSize.bodySm;
      },
      padding: 0,
      margin: [0, 0, spacing[2]],
      fontWeight: function (_a) {
        var muted = _a.muted,
          plain = _a.plain;
        return plain || muted ? type.fontWeight.regular : type.fontWeight.medium;
      }
    }
  };
});

var Label = function Label(_a) {
  var children = _a.children,
    htmlFor = _a.htmlFor,
    _b = _a.muted,
    muted = _b === void 0 ? false : _b,
    _c = _a.plain,
    plain = _c === void 0 ? false : _c,
    rest = __rest(_a, ["children", "htmlFor", "muted", "plain"]);
  var theme = useTheme();
  var wrenchLabel = useStyles({
    theme: theme,
    muted: muted,
    plain: plain
  }).wrenchLabel;
  return jsx("label", __assign({
    className: wrenchLabel,
    htmlFor: htmlFor
  }, safeRest(rest), {
    children: children
  }));
};

export { Label };
